(() => {
  if (window.PartnerPages) { window.PartnerPages.init(document); return; }
  const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  const initFaq = config => {
    const scope = config.closest('.faq-center-page') || config.closest('main') || config;
    config = scope.querySelector('[data-support-faq]') || config;
    scope.ppFaqController?.abort();
    const controller = new AbortController();
    scope.ppFaqController = controller;
    const options = {signal: controller.signal};
    let category = 'all';
    const update = () => {
      const input = scope.querySelector('[data-faq-search]');
      const words = normalise(input?.value || '').split(' ').filter(Boolean);
      let visible = 0;
      scope.querySelectorAll('[data-faq-item]').forEach(item => {
        const question = item.querySelector('[data-faq-question]')?.textContent || '';
        const answer = config.dataset.searchAnswers === 'true' ? item.querySelector('[data-faq-answer]')?.textContent || '' : '';
        const text = normalise(question + ' ' + answer);
        const matches = (category === 'all' || item.dataset.category === category) && words.every(word => text.includes(word));
        item.hidden = !matches;
        if (matches) visible += 1; else item.open = false;
      });
      scope.querySelectorAll('[data-faq-group]').forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some(item => !item.hidden);
      });
      const count = scope.querySelector('[data-faq-count]');
      const countTemplate = scope.querySelector('[data-faq-count-template]')?.textContent || '__COUNT__';
      if (count) count.textContent = countTemplate.replace('__COUNT__', visible);
      const empty = scope.querySelector('[data-faq-empty]');
      if (empty) empty.hidden = visible > 0;
      const clear = scope.querySelector('[data-faq-clear]');
      if (clear) clear.hidden = !words.length;
    };
    const setCategory = tab => {
      category = tab.dataset.faqFilter;
      scope.querySelectorAll('[data-faq-filter]').forEach(other => {
        other.classList.toggle('is-active', other === tab);
        other.setAttribute('aria-pressed', String(other === tab));
      });
      const heading = scope.querySelector('[data-faq-heading]');
      if (heading) heading.textContent = category === 'all' ? heading.dataset.defaultHeading : tab.textContent;
      update();
    };
    scope.addEventListener('click', event => {
      const tab = event.target.closest('[data-faq-filter]');
      if (tab && scope.contains(tab)) setCategory(tab);
      const clear = event.target.closest('[data-faq-clear]');
      if (clear) {
        const input = scope.querySelector('[data-faq-search]');
        if (input) {input.value = ''; update(); input.focus();}
      }
    }, options);
    scope.addEventListener('input', event => {if (event.target.matches('[data-faq-search]')) update();}, options);
    scope.addEventListener('toggle', event => {
      const item = event.target;
      if (item.matches('[data-faq-item]') && item.open && config.dataset.singleOpen === 'true') {
        scope.querySelectorAll('[data-faq-item]').forEach(other => {if (other !== item) other.open = false;});
      }
    }, {...options, capture: true});
    scope.addEventListener('pp:reveal', event => {
      const target = event.detail?.target;
      const selectedTab = target?.closest('[data-faq-filter]') || target?.querySelector('[data-faq-filter]');
      const group = target?.closest('[data-faq-group]') || target?.querySelector('[data-faq-group]');
      const item = target?.closest('[data-faq-item]') || group?.querySelector('[data-faq-item]');
      if (!selectedTab && !group && !item) return;
      const input = scope.querySelector('[data-faq-search]');
      if (input) input.value = '';
      const key = item?.dataset.category || group?.dataset.category;
      const tab = selectedTab || Array.from(scope.querySelectorAll('[data-faq-filter]')).find(tab => tab.dataset.faqFilter === key) || scope.querySelector('[data-faq-filter="all"]');
      if (tab) setCategory(tab);
      if (item) item.open = true;
    }, options);
    const allTab = scope.querySelector('[data-faq-filter="all"]');
    if (allTab) setCategory(allTab); else update();
  };
  const findApplication = root => {
    const scope = root.closest('.affiliate-program-page') || root.closest('main') || root;
    return scope.querySelector('.pp-affiliate__application');
  };
  const initAffiliate = root => {
    if (root.dataset.ppReady) return;
    root.dataset.ppReady = 'true';
    const panel = findApplication(root);
    if (panel?.querySelector('[data-application-result]')) panel.open = true;
    root.querySelectorAll('[data-open-application]').forEach(link => link.addEventListener('click', event => {
      const target = findApplication(root);
      if (!target) return;
      event.preventDefault();
      target.open = true;
      target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      target.querySelector('[data-application-result], input:not([type=hidden])')?.focus({preventScroll: true});
    }));
    if (panel && location.hash === '#' + panel.id) panel.open = true;
  };
  const init = scope => {
    const configs = new Set(scope.querySelectorAll('[data-support-faq], [data-faq-search-module]'));
    if (scope.matches?.('[data-support-faq], [data-faq-search-module]')) configs.add(scope);
    const page = scope.closest?.('.faq-center-page');
    const config = page?.querySelector('[data-support-faq], [data-faq-search-module]');
    if (config) configs.add(config);
    configs.forEach(initFaq);
    if (scope.matches?.('[data-affiliate-page]')) initAffiliate(scope);
    scope.querySelectorAll('[data-affiliate-page]').forEach(initAffiliate);
  };
  window.PartnerPages = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:reorder', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const faq = event.target.closest('.faq-center-page') || event.target.closest('[data-support-faq]');
    if (faq) faq.dispatchEvent(new CustomEvent('pp:reveal', {detail: {target: event.target}}));
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
